import { useCardContextValue } from '../state/CardContext';
import { MultiAccountCompany } from 'multi-account-crm-panel-lib/components/MultiAccountCompany';
import { MultiAccountContact } from 'multi-account-crm-panel-lib/components/MultiAccountContact';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const MultiAccountRecord = () => {
  const {
    objectTypeId,
    objectId
  } = useCardContextValue();
  if (objectTypeId === CONTACT_TYPE_ID) {
    return /*#__PURE__*/_jsx(MultiAccountContact, {
      contactId: objectId
    });
  } else if (objectTypeId === COMPANY_TYPE_ID) {
    return /*#__PURE__*/_jsx(MultiAccountCompany, {
      companyId: objectId
    });
  }
  return null;
};
export default MultiAccountRecord;